import { isEmpty } from "lodash";
import { CalendarMode, Row } from "PFApp/booking/types";
import React, { RefObject } from "react";

import { RowType } from "../../../../types/row";
import { getOriginalResource } from "../../../helpers";
import { WorkforceCalendarData } from "../../context/booking_overview_context.types";
import { useBookingRowsContext } from "../../context/booking_rows_context";
import { useBookingsOverviewContext } from "../../context/bookings_overview_context";
import Bars from "../bars/bars";
import Misalignments from "../bars/misalignments";
import { Overbookings } from "../bars/overbookings/overbookings";

interface BasicRowProps {
  mode: string;
  rowRef: RefObject<HTMLDivElement>;
  row: Row;
  startDate: string;
  endDate: string;
  onLoadingChange: (loading: boolean) => void;
  draggedBookingId: number | null;
  onBarDragStart: (bookingId: number) => void;
  onBarDragEnd: () => void;
  shouldBarsOverlap: boolean;
  titleDisabled?: boolean;
}

export const BasicRow = ({
  mode,
  rowRef,
  row,
  startDate,
  endDate,
  onLoadingChange,
  draggedBookingId,
  onBarDragStart,
  onBarDragEnd,
  shouldBarsOverlap,
  titleDisabled
}: BasicRowProps) => {
  const { calendarMode } = useBookingsOverviewContext<WorkforceCalendarData>();
  const { warningsByProfile } = useBookingRowsContext();

  const shouldDisplayMisalignments = mode === CalendarMode.Projects && row.type === RowType.Profile;
  const shouldDisplayOverbookings = mode === CalendarMode.Workforce && row.type === RowType.Profile;

  const getOverbookings = () => {
    if (!shouldDisplayOverbookings) {
      return [];
    }
    const profileId = getOriginalResource(row, calendarMode)?.id;
    return profileId ? warningsByProfile?.[profileId]?.overbookings : [];
  };

  const overbookings = getOverbookings();
  return (
    <>
      {shouldDisplayOverbookings && <Overbookings row={row} startDate={startDate} />}
      <Bars
        rowRef={rowRef}
        row={row}
        startDate={startDate}
        endDate={endDate}
        onLoadingChange={onLoadingChange}
        draggedBookingId={draggedBookingId}
        onBarDragStart={onBarDragStart}
        onBarDragEnd={onBarDragEnd}
        hasOverbookings={!isEmpty(overbookings)}
        shouldOverlap={shouldBarsOverlap}
        titleDisabled={titleDisabled}
      />
      {shouldDisplayMisalignments && (
        <Misalignments row={row} startDate={startDate} withPadding={!shouldBarsOverlap} />
      )}
    </>
  );
};
